import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfiguration } from '../../services/configuration/app.configuration';
import { resolveTestCountry, TEST_COUNTRY_HEADER } from '../../services/test-country/test-country';
import { isConfiguredStretchitApiRequest } from '../stretchit-api-headers/request-classifier';

/**
 * QA-only: на stage/dev добавляет `X-Test-Country` к запросам в наши API (`?test_country=BR`).
 * В production-сборке ничего не делает. Должен стоять после `stretchitApiHeadersInterceptor`,
 * который целиком заменяет заголовки запроса.
 */
export const testCountryInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(AppConfiguration);
  const country = resolveTestCountry(config.production);

  if (!country || !isConfiguredStretchitApiRequest(req, config)) return next(req);

  return next(req.clone({ setHeaders: { [TEST_COUNTRY_HEADER]: country } }));
};
